/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubjectContactResponseDto } from './subjectContactResponseDto.model';
import { RightToBuildDto } from './rightToBuildDto.model';
import { BuildingJpvDto } from './buildingJpvDto.model';
import { JpvDocumentDto } from './jpvDocumentDto.model';
import { ParcelDto } from './parcelDto.model';
import { JpvSectionSimpleDto } from './jpvSectionSimpleDto.model';
import { UnitDto } from './unitDto.model';


/**
 * Response of JPV section type of \'b1\', \'c\', \'d\' 
 */
export interface JpvSectionCommonDto { 
    buildingK?: BuildingJpvDto;
    buildingPro?: BuildingJpvDto;
    documents: Array<JpvDocumentDto>;
    id?: number;
    katuzeKod?: number;
    lv?: number;
    opsubKGroup?: string;
    opsubProGroup?: string;
    parcelK: ParcelDto;
    parcelPro?: ParcelDto;
    parcelRankK?: number;
    parcelRankPro?: number;
    popisPravnihoVztahu?: string;
    poradiCas?: string;
    poradiText?: string;
    relatedJpvs: Array<JpvSectionSimpleDto>;
    rightToBuildK?: RightToBuildDto;
    rightToBuildPro?: RightToBuildDto;
    subjectContactK?: SubjectContactResponseDto;
    subjectContactPro?: SubjectContactResponseDto;
    typravKod?: number;
    typravNazev?: string;
    unitK?: UnitDto;
    unitPro?: UnitDto;
}

